import { FormattedMessage, useIntl } from 'react-intl';
import { BANK_ACCOUNT_NUMBER_REGEXP, SORT_CODE_REGEXP } from 'common/regexp';
import { BankDetailsFieldsGroup, BankDetailsSection, BankDetailsTextField } from './components';

function formatSortCode(input: string): string {
  const digits = input.replace(/\D/g, '');
  return digits
    .slice(0, 6)
    .replace(/(\d{2})(\d{0,2})?(\d{0,2})?/, (_match, p1, p2, p3) => [p1, p2, p3].filter(Boolean).join('-'));
}

function formatAccountNumber(input: string): string {
  return input.replace(/\D/g, '').slice(0, 8);
}

interface AccountDetailsProps {
  disabled?: boolean;
}

export function AccountDetails({ disabled = false }: AccountDetailsProps) {
  const intl = useIntl();
  const requiredFieldErrorMessage = intl.formatMessage({ id: 'common.error.requiredField' });

  return (
    <BankDetailsSection titleId='applicationDetails.bankDetails.accountDetails.section'>
      <BankDetailsFieldsGroup>
        <div>
          <label className='mb-1 block text-sm text-[#000000E0]'>
            <FormattedMessage id='applicationDetails.bankDetails.accountName.label' />
          </label>
          <BankDetailsTextField
            name='accountDetails.accountName'
            disabled={disabled}
            rules={{ required: { value: true, message: requiredFieldErrorMessage } }}
          />
        </div>
        <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
          <div>
            <label className='mb-1 block text-sm text-[#000000E0]'>
              <FormattedMessage id='applicationDetails.bankDetails.accountNumber.label' />
            </label>
            <BankDetailsTextField
              name='accountDetails.accountNumber'
              disabled={disabled}
              maxLength={8}
              formatValue={formatAccountNumber}
              rules={{
                required: { value: true, message: requiredFieldErrorMessage },
                pattern: {
                  value: BANK_ACCOUNT_NUMBER_REGEXP,
                  message: intl.formatMessage({ id: 'btlApplicationForm.BANK_DETAILS.accountNumber.error' }),
                },
              }}
            />
          </div>
          <div>
            <label className='mb-1 block text-sm text-[#000000E0]'>
              <FormattedMessage id='applicationDetails.bankDetails.sortCode.label' />
            </label>
            <BankDetailsTextField
              name='accountDetails.sortCode'
              disabled={disabled}
              maxLength={8}
              formatValue={formatSortCode}
              rules={{
                required: { value: true, message: requiredFieldErrorMessage },
                pattern: {
                  value: SORT_CODE_REGEXP,
                  message: intl.formatMessage({ id: 'btlApplicationForm.BANK_DETAILS.sortCode.error' }),
                },
              }}
            />
          </div>
        </div>
        <div>
          <label className='mb-1 block text-sm text-[#000000E0]'>
            <FormattedMessage id='applicationDetails.bankDetails.bankName.label' />
          </label>
          <BankDetailsTextField
            name='accountDetails.bankName'
            disabled={disabled}
            rules={{ required: { value: true, message: requiredFieldErrorMessage } }}
          />
        </div>
      </BankDetailsFieldsGroup>
    </BankDetailsSection>
  );
}
